"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ObjUtils_1 = require("./ObjUtils");
var StringUtils_1 = require("./StringUtils");
var NumberUtils = /** @class */ (function () {
    function NumberUtils() {
    }
    NumberUtils.SafeToLong = function (value) {
        return this.SafeToInt(value);
    };
    NumberUtils.SafeToDouble = function (str) {
        if (!str || str === null)
            return 0;
        return Number.parseFloat(StringUtils_1.default.SafeToString(str));
    };
    NumberUtils.SafeToBool = function (Value) {
        if (Value === null)
            return false;
        return StringUtils_1.default.ParseBoolValue(Value.toString());
    };
    NumberUtils.SafeToInt = function (str, nDefault) {
        if (nDefault === void 0) { nDefault = 0; }
        if (ObjUtils_1.default.IsNothing(str))
            return nDefault;
        try {
            var retValue = Number.parseInt(StringUtils_1.default.SafeToString(str));
            return Number.isInteger(retValue) ? retValue : nDefault;
        }
        catch (e) {
            console.error(e);
            return nDefault;
        }
    };
    return NumberUtils;
}());
exports.default = NumberUtils;

//# sourceMappingURL=NumberUtils.js.map
